// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/drone.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/call icon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.need-a-quote-container{
    display: flex;
    justify-content: space-between;
}

.need-a-quote-action-container{
    color: white;
    display: inline;
    width: 55%;

}
.quote-title{
    font-size: 30px;
}

.quote-description{
    font-size: 20px;
    font-weight: lighter;
}

.quote-actions{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap:30px;
}
.phone-number-section{
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
}
.phone-number-section:hover{
    color: #0056b3;
}

.call-button{
    background-color: white;
    color: black;
    padding: 10px 28px;
    border-radius: 20px;
    font-size: 20px;
    cursor: pointer;
}

.call-button:hover{
    background-color: #0056b3;
    color: white;
}

.phone-number-title{
    font-size: 30px;
    font-weight: 700;
    line-height: 1.4em;
    letter-spacing: -1px;
    font-size: 26px;
    font-weight: bold;
}

.need-a-quote-image{
    width: 45%;
    height: 150px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
}

.phone-icon{
    width: 50px;
    height: 50px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
}

@media screen and (max-width: 600px) {
    .need-a-quote-container {
      display: inline-block;
      width: 100%;
    }
    .need-a-quote-image{
        display: none;
    }
    .quote-title{
        font-size: 18px;
    }
    .quote-description{
        font-size: 12px;
        font-weight: lighter;
    }
    .call-button{
        padding: 5px 25px;
        border-radius: 20px;
        font-size: 16px;
        font-weight: bold
    }
    .quote-actions{
        justify-content: space-around;
    }
    .phone-icon{
        width: 20px;
        height: 20px;
    }
    .phone-number-title{
        font-size: 18px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ServiceComponents/NeedAQuote/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,UAAU;;AAEd;AACA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;AACZ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,yDAAkD;IAClD,2BAA2B;IAC3B,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yDAAuD;IACvD,2BAA2B;IAC3B,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;IACI;MACE,qBAAqB;MACrB,WAAW;IACb;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,oBAAoB;IACxB;IACA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,eAAe;QACf;IACJ;IACA;QACI,6BAA6B;IACjC;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".need-a-quote-container{\n    display: flex;\n    justify-content: space-between;\n}\n\n.need-a-quote-action-container{\n    color: white;\n    display: inline;\n    width: 55%;\n\n}\n.quote-title{\n    font-size: 30px;\n}\n\n.quote-description{\n    font-size: 20px;\n    font-weight: lighter;\n}\n\n.quote-actions{\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap:30px;\n}\n.phone-number-section{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n}\n.phone-number-section:hover{\n    color: #0056b3;\n}\n\n.call-button{\n    background-color: white;\n    color: black;\n    padding: 10px 28px;\n    border-radius: 20px;\n    font-size: 20px;\n    cursor: pointer;\n}\n\n.call-button:hover{\n    background-color: #0056b3;\n    color: white;\n}\n\n.phone-number-title{\n    font-size: 30px;\n    font-weight: 700;\n    line-height: 1.4em;\n    letter-spacing: -1px;\n    font-size: 26px;\n    font-weight: bold;\n}\n\n.need-a-quote-image{\n    width: 45%;\n    height: 150px;\n    background-image: url(\"../../../assets/drone.png\");\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n}\n\n.phone-icon{\n    width: 50px;\n    height: 50px;\n    background-image: url(\"../../../assets/call\\ icon.png\");\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n}\n\n@media screen and (max-width: 600px) {\n    .need-a-quote-container {\n      display: inline-block;\n      width: 100%;\n    }\n    .need-a-quote-image{\n        display: none;\n    }\n    .quote-title{\n        font-size: 18px;\n    }\n    .quote-description{\n        font-size: 12px;\n        font-weight: lighter;\n    }\n    .call-button{\n        padding: 5px 25px;\n        border-radius: 20px;\n        font-size: 16px;\n        font-weight: bold\n    }\n    .quote-actions{\n        justify-content: space-around;\n    }\n    .phone-icon{\n        width: 20px;\n        height: 20px;\n    }\n    .phone-number-title{\n        font-size: 18px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
